import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SeoArticlePage from "../pages/article-seo/page";
import ShoppingGuide from "../pages/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/hoobuy-spreadsheet-guia",
    element: <ArticlePage />,
  },
  {
    path: "/artigo/:slug",
    element: <SeoArticlePage />,
  },
  {
    path: "/guia-de-compras",
    element: <ShoppingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;